import { Stack, Flex } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { Container } from "components";
import { DynamicComponent, renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import { contentStyles } from "modules/storyblok/adapters/Content";
import { Content } from "modules/storyblok/adapters";
import bgStyles from "components/Row/Row.styles";
import type { ContainerWithHeaderProps } from "./ContainerWithHeader.d";

export const ContainerWithHeader = ({
  sbEditable,
  header,
  description,
  bgStyle,
  components,
  id,
  display = "flex",
}: SbEditableComponentProps<ContainerWithHeaderProps>) => (
  <Flex flexDir="column" {...bgStyles[bgStyle as string]} pos="relative" id={id} display={display} {...sbEditable}>
    <Container>
      <Stack
        flexDir="column"
        align={{ base: "flex-start", md: "center" }}
        textAlign={{ base: "left", md: "center" }}
        spacing={{ base: 8, md: 6 }}
        px={{ base: 4, md: 8 }}
        pt={{ base: 8, md: 16, lg: 20 }}
      >
        {header && renderDynamicComponent(header)}
        {description && <Content blok={{ contentStyles, ...description[0] }} />}
      </Stack>
    </Container>
    {components?.map((component) => {
      const isAPRCards = component.component === "aPRCards";

      return isAPRCards ? (
        <DynamicComponent blok={component} key={component._uid} />
      ) : (
        <Container key={component._uid}>
          <DynamicComponent blok={component} />
        </Container>
      );
    })}
  </Flex>
);
